import React, { useEffect, useState, FC } from "react";
import { Row, Col, Table, Pagination, Button } from "antd";
import { datahelper, columns } from "../../helpers/history.helper";
import { useSearchParams } from "react-router-dom";
import TableForm from "../../components/tableForm";
import {
  filterParams,
  convertToServerFormat,
} from "../../helpers/function.helper";
import { GetHistoryList } from "../../api/history";
import { useGlobalState } from "../../context/Provider";
import { SearchOutlined } from "@ant-design/icons";
import { FormattedMessage } from "react-intl";
import NavigationMenu from "../../components/navigationMenu";
import TableTotalCount from "../../components/tableTotalCount";

const History: FC = () => {
  const [searchParams]: any = useSearchParams();
  const [loading, setLoading] = useState<boolean>(true);
  const [page, setPage] = useState<number>(1);
  const [data, setData] = useState<any>([]);
  const [total, setTotal] = useState<number>(0);
  const [menuVisible, setMenuVisible] = useState(false);
  const [form, setForm] = useState<any>(Object.fromEntries([...searchParams]));
  const { langState, warehouserList }: any = useGlobalState();

  const lang = langState.locale;

  useEffect(() => {
    handleHistoryApi();
  }, [page]);

  useEffect(() => {
    setPage(1);
    handleHistoryApi();
  }, [form]);

  const handleTableChange = (pagination: any, filters: any, sorter: any) => {
    handleHistoryApi(sorter.columnKey, sorter.order);
  };
  const handleHistoryApi = (sorting?: string, order?: string) => {
    const params = {
      Sorting: sorting,
      order: order === "descend" ? true : false,
      SkipCount: (page - 1) * 40,
      ProductName: form.productName,
      ManufacturerId: form.ManufacturerId,
      Sku: form.Sku,
      StartDate: form.rangeDate && convertToServerFormat(form.rangeDate[0]),
      EndTime: form.rangeDate && convertToServerFormat(form.rangeDate[1]),
    };
    const fp = filterParams(params);
    setLoading(true);
    GetHistoryList(fp).then((res: any) => {
      setLoading(false);
      if (res.status === 200) {
        setData(datahelper(res.data.items, page));
        setTotal(res.data.totalCount);
      }
    });
  };

  return (
    <Row gutter={[0, 24]} justify="center">
      <Col xs={0} md={23}>
        <TableForm setForm={setForm} setFormData={()=>{}}/>
      </Col>
      <Col xs={23} md={0}>
        <NavigationMenu visible={menuVisible} setVisible={setMenuVisible}>
          <TableForm setForm={setForm} isMobile setFormData={()=>{}} />
        </NavigationMenu>
      </Col>
      <Col xs={23} md={0}>
        <Button
          type="primary"
          icon={<SearchOutlined />}
          onClick={() => setMenuVisible(true)}
          className="d-flex align-items-center"
        >
          <div className="px-2">
            <FormattedMessage id="sku.search" />
          </div>
        </Button>
      </Col>
      <Col span={23}>
        <Table
          columns={columns(lang, warehouserList.data)}
          dataSource={data}
          size="middle"
          pagination={false}
          scroll={{ x: 1100, y: "calc(100vh - 310px)" }}
          loading={loading}
          onChange={handleTableChange}
        />
      </Col>
      <Col span={23}>
        <Row justify="space-between" align="middle">
          <Col>
            <Pagination
              defaultCurrent={1}
              total={total}
              defaultPageSize={40}
              showSizeChanger={false}
              onChange={(number) => setPage(number)}
            />
          </Col>
          <Col>
            <TableTotalCount total={total} />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default History;
